import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import { useScreens } from "../../app/context/screens";
import MonthForm from "./MonthForm";

export default function AddMonth({ goBack, warehouseValues }) {
  const { addMonth, setTotals } = useScreens();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const { addToast } = useToasts();

  console.log(warehouseValues);

  //TODO: extract function
  function totalUp(formValues) {
    let totals = warehouseValues.saQuantities;
    var month = warehouseValues.saQuantities.find((m) => {
      return m.name === formValues.month + " " + formValues.year;
    });

    if (!month) {
      let newMonth = {
        name: formValues.month + " " + formValues.year,
        month: formValues.month,
        year: formValues.year,
        recon: parseInt(formValues.recon),
        trauma: parseInt(formValues.trauma),
        spine: parseInt(formValues.spine),
        sportsmed: parseInt(formValues.sportsmed),
        extremity: parseInt(formValues.extremity),
        totalCases:
          parseInt(formValues.recon) +
          parseInt(formValues.trauma) +
          parseInt(formValues.spine) +
          parseInt(formValues.sportsmed) +
          parseInt(formValues.extremity),
        instruments: parseInt(formValues.instruments),
        implants: parseInt(formValues.implants),
        totalReservations:
          parseInt(formValues.instruments) + parseInt(formValues.implants),
      };
      totals.push(newMonth);
      setTotals(totals);
    } else {
      let totalUpdate = {
        name: formValues.month + " " + formValues.year,
        month: formValues.month,
        year: formValues.year,
        recon: parseInt(formValues.recon) + month.recon,
        trauma: parseInt(formValues.trauma) + month.trauma,
        spine: parseInt(formValues.spine) + month.spine,
        sportsmed: parseInt(formValues.sportsmed) + month.sportsmed,
        extremity: parseInt(formValues.extremity) + month.extremity,
        totalCases:
          parseInt(formValues.recon) +
          parseInt(formValues.trauma) +
          parseInt(formValues.spine) +
          parseInt(formValues.sportsmed) +
          parseInt(formValues.extremity) +
          month.totalCases,
        instruments: parseInt(formValues.instruments) + month.instruments,
        implants: parseInt(formValues.implants) + month.implants,
        totalReservations:
          parseInt(formValues.instruments) +
          parseInt(formValues.implants) +
          month.totalReservations,
      };
      const index = totals.findIndex(
        (i) => i.name === formValues.month + " " + formValues.year
      );
      totals[index] = totalUpdate;
      setTotals(totals);
    }
  }

  //TODO:Move to users context
  const handleSubmit = async (e, formValues, reset, createAnother) => {
    setLoading(true);
    e.preventDefault();

    let newMonth = {
      name: formValues.month + " " + formValues.year,
      month: formValues.month,
      year: formValues.year,
      recon: parseInt(formValues.recon),
      trauma: parseInt(formValues.trauma),
      spine: parseInt(formValues.spine),
      sportsmed: parseInt(formValues.sportsmed),
      extremity: parseInt(formValues.extremity),
      totalCases:
        parseInt(formValues.recon) +
        parseInt(formValues.trauma) +
        parseInt(formValues.spine) +
        parseInt(formValues.sportsmed) +
        parseInt(formValues.extremity),
      instruments: parseInt(formValues.instruments),
      implants: parseInt(formValues.implants),
      totalReservations:
        parseInt(formValues.instruments) + parseInt(formValues.implants),
    };

    console.log(newMonth);

    return addMonth(newMonth, formValues.area)
      .then(() => {
        addToast("Month added successfully", {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 1500,
          transitionDuration: 10,
          transitionState: "entered",
        });
        totalUp(formValues);
        setLoading(false);
        goBack();
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);

        setError(error);
        console.log(error);
      });
  };

  return (
    <MonthForm
      loading={loading}
      error={error}
      handleSubmit={handleSubmit}
      submitText="Add Month"
      create={false}
      cancel={goBack}
      initialValues={{ role: undefined }}
    />
  );
}
